export const scrollToSection = (hash) => {
    const lenis = window.__lenis;
    if (lenis) {
        lenis.scrollTo(hash, { offset: -72, duration: 1.6 });
    } else {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
    }
};

export const hasWebGL = () => {
    try {
        return !!document.createElement("canvas").getContext("webgl");
    } catch {
        return false;
    }
};
